import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getServiceTypes,
  clearErrorGettingServiceTypes,
  getAllServiceTypes,
  clearServiceTypes,
} from '../../../../actions/index';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';

const ServiceTypeSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchGetServiceTypes,
  dispatchClearErrorGettingServiceTypes,
  dispatchGetAllServiceTypes,
  dispatchClearServiceTypes,
  showAll,
  showOnlyIsCommercial,
  ...rest
}) => {
  useEffect(() => {
    if (showAll) {
      dispatchGetAllServiceTypes({ showOnlyIsCommercial });
    }

    return () => {
      dispatchClearErrorGettingServiceTypes();
      dispatchClearServiceTypes();
    };
  }, []);

  const handleInputChange = (inputValue) => {
    if (showAll) return;
    if (inputValue.trim().length && inputValue.trim().length >= 4) {
      dispatchGetServiceTypes(inputValue, { showOnlyIsCommercial });
    }
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={handleInputChange}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

ServiceTypeSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetServiceTypes: PropTypes.func.isRequired,
  dispatchClearErrorGettingServiceTypes: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  dispatchGetAllServiceTypes: PropTypes.func.isRequired,
  showAll: PropTypes.bool,
  showOnlyIsCommercial: PropTypes.bool,
  dispatchClearServiceTypes: PropTypes.func.isRequired,
};

ServiceTypeSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  showAll: false,
  showOnlyIsCommercial: false,
};

const mapStateToProps = ({ BusUnit }) => ({
  options: BusUnit.ServiceType.getIn(['all', 'content', 'content']).map(
    (service) => ({
      value: service.id,
      label: service.name,
    }),
  ),
  loading: BusUnit.ServiceType.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetServiceTypes: getServiceTypes,
  dispatchClearErrorGettingServiceTypes: clearErrorGettingServiceTypes,
  dispatchGetAllServiceTypes: getAllServiceTypes,
  dispatchClearServiceTypes: clearServiceTypes
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceTypeSelect);
